import { combineReducers, createStore } from 'redux';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage'; // defaults to localStorage for web
import sessionStorage from 'redux-persist/lib/storage/session';
import { rootReducer, categoryReducer } from './reducers';

const persistConfig = {
  key: 'root',
  storage,
};

const categoryPersistConfig = {
  key: 'category',
  storage: sessionStorage,
};

const persistedReducer = combineReducers({
  root: persistReducer(persistConfig, rootReducer),
  category: persistReducer(categoryPersistConfig, categoryReducer),
});

const store = createStore(persistedReducer);
const persistor = persistStore(store);

export { store, persistor };
